import styled, {AnyStyledComponent, FlattenInterpolation, ThemedStyledProps} from 'styled-components';

type AnnotationFunction = (
  baseComponent: AnyStyledComponent,
  annotationComponents: FlattenInterpolation<ThemedStyledProps<any, any>>
) => string

const themeAnnotation: AnnotationFunction = (styledComponent, ...args) => styled(styledComponent)`${args}` as string;

export {
  themeAnnotation,
};

export {Input} from './components/Input';
